import "./styles/global.css";
import "./ui/app.css";
import { trackEvent } from "./analytics";
import { install as installErrorBoundary, guard } from "./errorBoundary";
import { mountApp } from "./ui/app";
import { installConsent } from "./consent";
import { mountFooter } from "./shared/footer";
import { loadAdSenseOnConsent } from "./ads/adsense";

const container = document.querySelector<HTMLElement>("#app");
if (container) {
  installErrorBoundary(container);
  const mounted = guard(() => {
    mountApp(container);
    return true;
  });
  if (mounted) trackEvent("visit");
}

const consent = installConsent();
mountFooter();
loadAdSenseOnConsent({ consent });
